<div
    class="relative h-full w-full transform-gpu"
    [ngClass]="additionalClasses"
    appIntersectionObserver
    [intersectionDebounce]="100"
    [intersectionThreshold]="0.001"
    (visibilityChange)="onVisibilityChange($event)">
    <video
        #video
        [ngClass]="additionalVideoClasses"
        (ended)="videoEnded()"
        class="object-initial absolute box-border h-full w-full"
        disableRemotePlayback
        playsinline
        preload="none">
        <source [src]="mp4src" type="video/mp4" />
    </video>
    @if (poster && !playing && !started) {
        <img
            class="lazyload absolute h-full w-full"
            [attr.data-src]="poster"
            alt=""
            [ngClass]="additionalVideoClasses" />
    }
    @if (showBuffering) {
        <div
            [ngClass]="bufferingClasses | async"
            class="flexer-col absolute h-full w-full justify-center bg-lightgrey transition duration-200">
            <app-loader color="#FFF"></app-loader>
        </div>
    }
    <div
        class="no-tap-highlight group absolute flex h-full w-full cursor-pointer flex-col items-center justify-center"
        (click)="togglePlayPause()">
        @if (!playing) {
            <button
                class="w-auto rounded-fa bg-white bg-opacity-75 px-12 py-4 shadow transition duration-0 hover:bg-opacity-90 active:bg-opacity-100 active:shadow-inner">
                <fa-icon [icon]="faPlay" size="2x" class="text-red"> </fa-icon>
            </button>
        }
        @if (playing) {
            <button
                class="hidden w-auto bg-transparent px-12 py-4 opacity-50 transition duration-0 hover:opacity-80 md:group-hover:block">
                <fa-icon
                    [icon]="faPause"
                    size="3x"
                    class="text-white"></fa-icon>
            </button>
        }
    </div>
    <ng-content></ng-content>
</div>
